import en  from './en.json';
import ru  from './ru.json';

export const dictionaryList: any = { en, ru };

export const languageOptions: any = {
    en: 'EN',
    ru: 'RU'
};